module.exports = __webpack_public_path__ + "static/media/loading5.497ced13.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading5.png
// module id = 190
// module chunks = 0